import { graphql } from 'react-relay';

export const categoryInfoEntryFragment = graphql`
    fragment CategoryInfoEntry_entry on CategoryInfoEntry {
        label
        value
    }
`;
